import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function EmotionalHook() {
  return <section className="py-8 px-4 bg-sage-50 relative" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        type: 'spring',
        stiffness: 180,
        damping: 20
      }} className="relative" data-id="element-21">
          {/* Floating clock badge */}
          <motion.div initial={{
          scale: 0,
          rotate: -20
        }} whileInView={{
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          type: 'spring',
          stiffness: 250
        }} className="absolute -top-5 left-1/2 -translate-x-1/2 z-10 bg-naranja-500 text-white p-3 rounded-2xl shadow-lg flex items-center gap-2" data-id="element-22">
            <Clock className="w-5 h-5" data-id="element-23" />
            <span className="font-black text-sm" data-id="element-24">Día de Escuela</span>
          </motion.div>

          <div className="bg-white rounded-3xl p-7 md:p-10 shadow-[0_8px_30px_-6px_rgba(0,0,0,0.1)] border border-cream-200 relative overflow-hidden" data-id="element-25">
            {/* Subtle accent stripe */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-naranja-500 via-mostaza-500 to-sage-500" data-id="element-26"></div>

            <h2 className="text-2xl md:text-3xl font-black text-center text-charcoal-900 mt-4 mb-6" data-id="element-27">
              Son las <span className="text-naranja-500" data-id="element-28">7:15 AM</span>...
            </h2>

            <div className="space-y-4 text-base md:text-lg text-charcoal-800 leading-relaxed" data-id="element-29">
              <p data-id="element-30">
                Tienes un zapato puesto, el café se está enfriando en la barra y
                abres el refrigerador con{' '}
                <strong className="text-charcoal-900" data-id="element-31">
                  la mente en blanco
                </strong>
                . Miras el reloj: el transporte escolar llega en{' '}
                <strong className="text-naranja-600" data-id="element-32">15 minutos</strong>.
              </p>
              <p data-id="element-33">
                Suspiras, tomas una rebanada de pan, un poco de{' '}
                <strong className="text-charcoal-900" data-id="element-34">jamón procesado</strong> y
                una manzana que ha visto mejores días. Cierras la mochila con un{' '}
                <strong className="text-charcoal-900" data-id="element-35">
                  nudo en el estómago
                </strong>
                . Sabes que tu hijo necesita{' '}
                <strong className="text-sage-700" data-id="element-36">energía real</strong> para
                aprender, pero la prisa te ha vuelto a ganar.
              </p>
            </div>

            <motion.div initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="mt-6 bg-naranja-100 p-5 rounded-2xl border-l-4 border-naranja-500 flex items-start gap-3" data-id="element-37">
              <AlertTriangle className="w-6 h-6 text-naranja-500 flex-shrink-0 mt-0.5" data-id="element-38" />
              <p className="font-bold text-charcoal-900 italic text-base leading-snug" data-id="element-39">
                "No eres una 'mala madre'. Simplemente estás tratando de
                sobrevivir con un sistema de alimentación que fue diseñado para
                personas con{' '}
                <span className="text-naranja-600" data-id="element-40">3 horas libres al día</span>
                ."
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}